import { GENIE_ICON, GIFT_ICON, TIMER_ICON } from '../../constants/gamesConstants';

export const FETCH_SCRATCHCARD_QUESTION_API_SUCCESS = 'FETCH_SCRATCHCARD_QUESTION_API_SUCCESS';
export const FETCH_SCRATCHCARD_QUESTION_API_ERROR = 'FETCH_SCRATCHCARD_QUESTION_API_ERROR';
export const FETCH_SCRATCHCARD_ANSWER_API_SUCCESS = 'FETCH_SCRATCHCARD_ANSWER_API_SUCCESS';
export const FETCH_SCRATCHCARD_ANSWER_API_ERROR = 'FETCH_SCRATCHCARD_ANSWER_API_ERROR';
export const FETCH_SCRATCHCARD_RULES_API_CONTENT = 'FETCH_SCRATCHCARD_RULES_API_CONTENT';
export const EMPTY_GAME_TYPE_FROM_GAME_URL = 'gameType value is missing from game page url';
export const EMPTY_GAME_NAME_FROM_GAME_URL = 'gameName value is missing from game page url';
export const GUEST_USER_ACCESSING_GAME_URL =
  'user not logged-in while accessing scratchcard game page url';
export const INCORRECT_JSON_RECEIVED_FROM_BACKEND_FOR_QUESTION =
  'Incorrect JSON content received from Hybris while fetching SCRATCHCARD question.';
export const EMPTY_SCRATCHCARD_QUESTION_RECEIVED = 'empty question received from back-end';
export const TOKEN_RECREATION_FAILED_FOR_QUESTION_FETCH =
  'Token re-creation failed at node level for quiz /start api';
export const ANSWER_LIST_TYPE = ['A', 'B', 'C', 'D'];
export const GAME_STATUSES = {
  VIEW_SCORE_CARD: 'VIEW_SCORE_CARD',
  PLAY_GAME: 'PLAY_GAME',
  VIEW_ERROR_MODAL: 'VIEW_ERROR_MODAL',
  VIEW_SCORE_CARD_AND_ERROR_MODAL: 'VIEW_SCORE_CARD_AND_ERROR_MODAL'
};
export const OFFER_TYPE_AJIO_CASH = 'AJIO_CASH';
export const OFFER_TYPE_AJIO_POINTS = 'AJIO_POINTS';
export const OFFER_TYPE_NO_OFFER = 'NO_OFFER';
export const OFFER_TYPE_PROMO_COUPON = 'PROMO_COUPON';
export const QUIZ_OWNED_AND_ELIGABLE_TO_PLAY = 'QUIZ_OWNED_AND_ELIGABLE_TO_PLAY';
export const QUIZ_OWNED_AND_NOT_ELIGABLE_TO_PLAY = 'QUIZ_OWNED_AND_NOT_ELIGABLE_TO_PLAY';
export const QUIZ_LOST_AND_ELIGABLE_TO_PLAY = 'QUIZ_LOST_AND_ELIGABLE_TO_PLAY';
export const QUIZ_LOST_AND_NOT_ELIGABLE_TO_PLAY = 'QUIZ_LOST_AND_NOT_ELIGABLE_TO_PLAY';

export const UPDATE_QUIZ_OWNED_AND_ELIGABLE_TO_PLAY = 'UPDATE_QUIZ_OWNED_AND_ELIGABLE_TO_PLAY';
export const UPDATE_QUIZ_OWNED_AND_NOT_ELIGABLE_TO_PLAY =
  'UPDATE_QUIZ_OWNED_AND_NOT_ELIGABLE_TO_PLAY';
export const UPDATE_QUIZ_LOST_AND_ELIGABLE_TO_PLAY = 'UPDATE_QUIZ_LOST_AND_ELIGABLE_TO_PLAY';
export const UPDATE_QUIZ_LOST_AND_NOT_ELIGABLE_TO_PLAY =
  'UPDATE_QUIZ_LOST_AND_NOT_ELIGABLE_TO_PLAY';
export const QUIZ_MODAL_STYLE_FOR_MOBILE = {
  content: {
    position: 'relative',
    right: 'auto',
    bottom: 'auto',
    width: '100%',
    height: '100vh',
    background: 'transparent',
    border: 'none',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    overflowY: 'scroll',
    overflowX: 'hidden'
  },
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.8)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflowY: 'hidden',
    zIndex: 10,
    transition: `opacity 400ms ease-in-out 0.4s`
  }
};

export const QUIZ_MODAL_STYLE_FOR_DESKTOP = {
  content: {
    position: 'relative',
    right: 'auto',
    bottom: 'auto',
    width: '100%',
    height: '100vh',
    background: 'transparent',
    border: 'none',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    overflowY: 'scroll',
    overflowX: 'hidden'
  },
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.8)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflowY: 'hidden',
    top: 'unset',
    zIndex: 101,
    height: '88vh',
    transition: `opacity 400ms ease-in-out 0.4s`
  }
};

export const EARN_REWARD_API_ERROR_MESSAGES = [
  {
    errorCode: 400,
    icon: GIFT_ICON,
    errorMessage:
      'This game is not active now.<br />However do not miss out on our exciting offers',
    btnText: 'Continue Shopping',
    btnActionType: 'OPEN_HOME_PAGE',
    errorType: 'Game Not Found / Does not exist'
  },
  {
    errorCode: 454,
    icon: GIFT_ICON,
    errorMessage:
      'This game is not active now.<br />However do not miss out on our exciting offers',
    btnText: 'Continue Shopping',
    btnActionType: 'OPEN_HOME_PAGE',
    errorType: 'Game Not Found / Does not exist'
  },
  {
    errorCode: 500,
    icon: TIMER_ICON,
    errorMessage:
      'Hey, we are experiencing high traffic. Kindly check the rewards page in some time to view your winnings!',
    btnText: 'Okay',
    btnActionType: 'CLOSE_MODAL',
    errorType: 'Internal Server Error'
  },
  {
    errorCode: 503,
    errorMessage:
      'Hey, we are experiencing high traffic. Kindly check the rewards page in some time to view your winnings!',
    icon: TIMER_ICON,
    btnText: 'Okay',
    btnActionType: 'RELOAD',
    errorType: 'Service Unavailable'
  },
  {
    errorCode: 504,
    errorMessage: 'Hey, we are experiencing heavy traffic, please try again after some time',
    icon: TIMER_ICON,
    btnText: 'Okay',
    btnActionType: 'CLOSE_MODAL',
    errorType: 'Gateway Timeout'
  },
  {
    errorCode: 16,
    icon: TIMER_ICON,
    errorMessage:
      'Hey, we are experiencing high traffic. Kindly check the rewards page in some time to view your winnings!',
    btnText: 'Okay',
    btnActionType: 'CLOSE_MODAL',
    errorType: 'REWARD_NOT_FOUND_ERROR'
  },
  {
    errorCode: 17,
    icon: TIMER_ICON,
    errorMessage: "Oops! You're late. Your scratch card has expired a moment ago.",
    btnText: 'Okay',
    btnActionType: 'CLOSE_MODAL',
    errorType: 'SCRATCH_CARD_EXPIRED_ERROR'
  }
];

export const START_API_ERROR_MESSAGES = [
  {
    errorCode: 454,
    icon: GIFT_ICON,
    errorMessage:
      'This game is not active now.<br />However do not miss out on our exciting offers',
    btnText: 'Continue Shopping',
    btnActionType: 'OPEN_HOME_PAGE',
    errorType: 'Game Not Found / Does not exist'
  },
  {
    errorCode: 504,
    errorMessage: 'Hey, we are experiencing heavy traffic, please try again after some time',
    icon: TIMER_ICON,
    btnText: 'Okay',
    btnActionType: 'CLOSE_MODAL',
    errorType: 'Gateway Timeout'
  },
  {
    errorCode: 503,
    errorMessage: 'Hey, we are experiencing heavy traffic, please try again after some time',
    icon: TIMER_ICON,
    btnText: 'Okay',
    btnActionType: 'RELOAD',
    errorType: 'Service Unavailable'
  },
  {
    errorCode: 400599,
    icon: TIMER_ICON,
    errorMessage:
      'Hey, we are experiencing high traffic. Kindly check the rewards page in some time to view your winnings!',
    btnText: 'Okay',
    btnActionType: 'CLOSE_MODAL',
    errorType: 'Internal Server Error'
  }
];
